import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {HttpGetUserAvailabilityOptions, httpGetUserAvailability} from '../http/users-availability.http'
import {UserAvailability} from '../types'

export const useGetUserAvailability = (
    params: HttpGetUserAvailabilityOptions,
    options?: Omit<UseQueryOptions<UserAvailability, Error>, 'queryKey' | 'queryFn'>
) => {
    return useQuery<UserAvailability, Error>({
        queryKey: [QUERY_KEYS.USER_AVAILABILITY, params.urlParams.userId],
        queryFn: () => httpGetUserAvailability(params),
        ...options
    })
}
